import React from "react";
import Container from "../common/Container";
import SectionHeader from "../common/SectionHeader";
import { ShieldCheck, Rocket, Users, Settings } from "lucide-react";

const reasons = [
  {
    title: "Quality First",
    description:
      "We follow industry best practices, clean architecture, and rigorous testing to deliver reliable software.",
    icon: ShieldCheck,
  },
  {
    title: "Agile & Fast",
    description:
      "Our agile process ensures rapid iterations, faster releases, and complete transparency.",
    icon: Rocket,
  },
  {
    title: "Client-Centric",
    description:
      "We work as an extension of your team, aligning technology with your business goals.",
    icon: Users,
  },
  {
    title: "Scalable Solutions",
    description:
      "We build future-ready systems that grow with your business and adapt to change.",
    icon: Settings,
  },
];

const WhyUs = () => {
  return (
    <section className="bg-slate-50 py-24">
      <Container>
        <center>
        <SectionHeader
          eyebrow="Why Brightly"
          title="A technology partner you can trust"
          subtitle="We don’t just build software — we help businesses create long-term value through technology."
        />
        </center>

        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {reasons.map((item) => (
            <div
              key={item.title}
              className="flex flex-col items-center text-center px-6"
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-600 text-white shadow-lg shadow-blue-600/30">
                <item.icon size={26} />
              </div>

              <h3 className="mt-6 text-lg font-semibold text-slate-900">
                {item.title}
              </h3>

              <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WhyUs;
